// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { CalculationsMap, CalculationType, DEFAULT_CALCULATION } from '@perses-dev/plugin-system';
import { TimeSeries } from '@perses-dev/spec';

export const calculateValue = (
  calculation: CalculationType,
  seriesData: TimeSeries
): ReturnType<(typeof CalculationsMap)[CalculationType]> => {
  if (CalculationsMap[calculation] === undefined) {
    console.warn(`Invalid StatChart panel calculation ${calculation}, fallback to ${DEFAULT_CALCULATION}`);
  }
  const calculate = CalculationsMap[calculation] ?? CalculationsMap[DEFAULT_CALCULATION];
  return calculate(seriesData.values);
};
